//disabling pageTracker. We are now async. Using this till flash is fixed.
// get rid of this when complete.

window.pageTracker = {
  _trackPageview: function () { log("_trackPageview", arguments); return true; },
  _trackEvent: function () { log("_trackEvent", arguments); return true; },
  _setVar: function () { log("_setVar", arguments); return true; }
};

window.log = ((slideshare_object.dev && window.console) ?
  (function () { console.log.apply(console, arguments); }) :
  (function () { }));
String.prototype.supplant = function (o) {
  return this.replace(/\{([^{}]*)\}/g,
    function (a, b) {
      var r = o[b];
      return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
};

(function ($) {
  $.fn.extend({
    // click and stop event propagation or browser defaults
    jsclick: function (fn) {
      var that = this;
      var newfn = function (event) { fn.apply(that, arguments); event.preventDefault(); event.stopPropagation(); };
      this.click(newfn);
      return newfn;
    },
    jschange: function (fn) {
      var that = this;
      var newfn = function (event) { fn.apply(that, arguments); event.preventDefault(); event.stopPropagation(); };
      this.change(newfn);
      return newfn;
    },
    jssubmit: function (fn) {
      var that = this;
      var newfn = function (event) { fn.apply(that, arguments); event.preventDefault(); event.stopPropagation(); };
      this.submit(newfn);
      return newfn;
    },
    add_undo: function (mesg, fn) {
      if (slideshare_object.ajax_undo) {
        slideshare_object.ajax_undo.push([mesg, fn, this]);
      }
    },
    // click to toggle show/hide something else
    showhide: function (sel, scope) {
      this.jsclick(function () {
        $(sel, scope).toggle();
        if (slideshare_object.align_lostchildren) {
          slideshare_object.align_lostchildren();
        }
      });
      return this;
    }
  });
})(jQuery);

slideshare_object.ready = (function () { // not using: jQuery(document.body).ready(function() {
  var i18n = slideshare_object.utils.i18n,
    loading_text = i18n("slideshow.foundation_slideview.loading_text"),
    loading_html = i18n("slideshow.foundation_slideview.loading");

  slideshare_object.timer.ready = (new Date()).getTime();
  slideshare_object.ajax_undo = [];

  slideshare_object.add_undo = function (mesg, fn) {
    slideshare_object.ajax_undo.push([mesg, fn]);
  };

  $(document).ajaxError(function (event, request, settings, err) {
    log("ajaxError", event, request, settings, settings.url, err);
    var undofn = slideshare_object.ajax_undo.shift();
    if (undofn && undofn[2]) { undofn[2].trigger('ajaxFail', arguments); }
    if (undofn) {
      // alert("There was a problem " + undofn[0]);
      undofn[1](event, request, settings, err);
    }
  });

  $(document).ajaxSuccess(function (event, request, settings) {
    var undofn = slideshare_object.ajax_undo.shift();
    if (undofn && undofn[2]) { undofn[2].trigger('ajaxOkay', arguments); }
  });

  slideshare_object.sessid = encodeURIComponent((document.cookie.match(/_cookie_id=([^;]*)/) || [])[1]);
  slideshare_object.add_deferred = function (fn) {
    if (!slideshare_object.deferred) {
      slideshare_object.deferred = {
        list: [],
        timeout: null,
        next_action: function () {
          log("Wakie wakie!");
          var fn = slideshare_object.deferred.list.shift();
          if (fn) { fn(); }
          if (slideshare_object.deferred.list[0]) {
            if (slideshare_object.deferred.timeout) {
              clearTimeout(slideshare_object.deferred.timeout);
            }
            slideshare_object.deferred.timeout = setTimeout(slideshare_object.deferred.next_action, 100);
          }
        }
      };
    }
    if (slideshare_object.deferred.timeout) {
      clearTimeout(slideshare_object.deferred.timeout);
    }
    slideshare_object.deferred.list.push(fn);
    slideshare_object.deferred.timeout = setTimeout(slideshare_object.deferred.next_action, 200);
  };

  if (slideshare_object.lead && slideshare_object.lead.form_url) {
    $('.noAdForLead').remove();
  }

  slideshare_object.slideshowCategories = $('#slideshow-categories');
  slideshare_object.suonly = $('ul.superuser-only');
  slideshare_object.svComments = jQuery('.commentsNotes');
  slideshare_object.svCommentsul = jQuery('#commentsList');
  slideshare_object.svCommentsForm = $('form.j-comment-post');
  slideshare_object.svTools = $('.j-tools');
  slideshare_object.svEmbed = $('.details .embed');
  slideshare_object.loading_html = '<span class="j-loading">' + loading_text +
    ' <img alt="' + loading_html + '" ' +
    'src="//public.slidesharecdn.com/images/indicator.gif" ' +
    'height="5" width="21" style="margin:0;float:none;vertical-align:middle" /></span>';

  $(document).ready(function () {
    var slideNumArray = window.location.hash.match(/\d+/);
    if (slideNumArray && slideNumArray.length > 0) {
      var slideNo = parseInt(slideNumArray[0], 10);
      $('.slide.show').removeClass('show');
      $('.slide[data-index=' + slideNo + ']').addClass('show');
      window.player.goToSlide({ index: slideNo });
    }
    if (slideshare_object && slideshare_object.jsplayer &&
      slideshare_object.jsplayer.bambooleaf_presentation) {
      // Track loading of bambooleaf presentations here for analysis of effect
      $.slideshareEventManager && $.slideshareEventManager.trackRawEvent(
        'bambooleaf_load',
        slideshare_object.jsplayer.id + "-" +
        slideshare_object.jsplayer.start_slide,
        document.referrer,
        true
      );
    }
    // Social sharing callbacks
    var shareStatus = {};
    $('.j-share-item').on('click', function (e) {

      // Get the network name
      var network = $(this).data('network');
      var shareURL = slideshare_object.slideshow.social_urls[network];
      var $count = $(this).find('.j-share-count');
      var num = parseInt($count.text().replace(/,/g, ""), 10);

      // Open the popup
      window.open(shareURL, 'shareDialog', 'width=' + 626 + ',height=' + 436);

      // Track the click
      $.slideshareEventManager && $.slideshareEventManager.trackRawEvent(
        'bigfoot_slideview',
        $(this).data('ga-action')
      );

      // Increase the number by 1
      if (shareStatus[network] === undefined) {
        $count.text((num + 1).toLocaleString());
      }
      shareStatus[network] = 1;
    });

    var recommendations = [];
    $(".j-related-impression").each(function () {
      recommendations.push({
        'slideshow_id': $(this).data('ssid'),
        'score': $(this).data('score')
      });
    });

    var lyndaImpressions = $('.j-lynda-impression');

    if (lyndaImpressions.length) {
      var lyndaImpressionJson = {
        "ssid": lyndaImpressions.data('ssid'),
        "lyndaInfoArr": [],
        "designkey": lyndaImpressions.data('designkey')
      }, eventCategory;

      lyndaImpressions.each(function () {
        var impression = $(this),
          lyndaInfo;

        if (!impression.data('tracking-id')) {
          // TODO: Use generateTrackingID from tracking-utils.js
          impression.data('tracking-id', slideshare_object.generateTrackingID(16));
        }

        lyndaInfo = {
          "id": impression.data('lynda-id'),
          "type": impression.data('lynda-type'),
          "algorithm-id": impression.data('algorithm-id')
        };

        if (eventCategory === undefined) {
          if (impression.hasClass('j-lynda-category')) {
            eventCategory = 'related_lynda_cat_impression_2';
          } else {
            // This is a course, find out the course type
            var courseType = impression.data('course-type');
            if (courseType === 'v2b') {
              eventCategory = 'related_v2b_impressions_2';
              // Only v2b courses have non-english language
              lyndaImpressionJson.designkey = lyndaImpressionJson.designkey +
                '_' + impression.data('language');
            } else if (courseType === '') {
              eventCategory = 'related_lynda_impressions_2';
            }
          }
        }
        lyndaImpressionJson.lyndaInfoArr.push(lyndaInfo);
      });

      $.slideshareEventManager && $.slideshareEventManager.trackRawEvent(
        eventCategory,
        JSON.stringify(lyndaImpressionJson),
        null,
        true
      );
    }

    lyndaImpressions.on('click', function () {
      var trackingJson = {
        "ssid": $(this).data('ssid'),
        "lynda-id": $(this).data('lynda-id'),
        "designkey": $(this).data('designkey'),
        "lynda-type": $(this).data('lynda-type'),
        "algorithm-id": $(this).data('algorithm-id'),
        "eid": $(this).data('tracking-id')
      }, event_category;
      if ($(this).hasClass('j-lynda-category')) {
        event_category = 'related_lynda_cat_click';
      } else {
        // This is a course, find out the course type
        var courseType = $(this).data('course-type');
        if (courseType === 'v2b') {
          event_category = 'related_v2b_clicks';
          // Only v2b courses have non-english language
          trackingJson.designkey = trackingJson.designkey +
            '_' + $(this).data('language');
        } else if (courseType === '') {
          event_category = 'related_lynda_clicks';
        }
      }
      $.slideshareEventManager && $.slideshareEventManager.trackRawEvent(
        eventCategory,
        JSON.stringify(trackingJson),
        null,
        false
      );
    });

    var time = (new Date()).getTime(),
      recommendation_id = slideshare_object.presentationId + '_' + time,
      data = {
        'module_id': 'sv_right',
        'user_id': slideshare_object.user.id,
        'source': slideshare_object.presentationId,
        'recommendations': recommendations,
        'algorithmId': $($(".j-related-impression")[0]).data("algo-id")
      },
      entity = { 'recommendation_id': recommendation_id };

    if (getUrlVar('related') !== undefined) {
      data.trackingCode = 'related';
    } else if (getUrlVar('next_slideshow') !== undefined) {
      data.trackingCode = 'next_slideshow';
    }

    $('.j-action-categorize').on('click', function (e) {
      $('.j-overlay-categorize').toggle();
      $(window).scrollTop(0);
    });

    $('.j-action-sucategorize-submit').click(function (e) {
      e.preventDefault();
      $('.j-progress').show();
      var value = $("#featured_value option:selected").val();

      // Send to home page
      $.post(slideshare_object.su.post_homepage_url, {
        featured_value: value
      });

      // Categorize the slideshow
      var change_type = $('#slideshow_type').get(0);
      var url = "/ssadmin/update_editor_details/" + slideshare_object.presentationId;
      var url_data = $('#categorize-form').serialize();
      $.post(url, url_data, function (data) {
        $('.j-progress').hide();
        $('.j-overlay-categorize').hide();
        if (change_type && change_type.checked === true) {
          window.location.reload();
        }
      }, 'json');
    });

    $('.action-sucategorize-cancel').click(function (e) {
      $('.j-progress').hide();
      $('.j-overlay-categorize').hide();
    });

    $('a[href="/login"]').filter(':not(.void_redirect_link)')
      .attr('href', '/login?from_source=' + encodeURIComponent(window.location.pathname));

    //Trigger GA when the page is called from fb app
    var fb_source = getUrlVar('fb_source');
    if (getUrlVar('code') || fb_source) {
      if (fb_source) {
        slideshare_object.ga('fb_opengraph', 'slideview_visit', fb_source);
      } else {
        slideshare_object.ga('fb_opengraph', 'slideview_visit', 'no_fb_source');
      }
    }
    slideshare_object.processAdQueue && slideshare_object.processAdQueue();
    slideshare_object.topRightAd = $(".j-top-right-div iframe");
    //this is to refresh the 300x250 ad on every 5th slide change
    slideshare_object.topRightAd.length && slideshare_object.topRightAd.bind("refreshAd", (function () {
      var slidesMoved = 0;
      var refreshCounter = 0;
      var adSource = slideshare_object.topRightAd.attr('src');
      //need to remove adsense=t param at first refresh (it's not required after that)
      //other part of url is constant and hence can be used as is on each refresh
      adSource = adSource.replace(encodeURIComponent("adsense=t;"), "");

      return function (e) {
        slidesMoved += 1;
        if (slidesMoved === 5) {
          slidesMoved = 0;
          refreshCounter++;

          //refreshcount is incremented for each refresh and is required
          //to track no. of ad refresh's

          //Replace ad iframe with a new iframe before updating the src attribute
          //to avoid going to the previous ad when a user clicks 'back'
          var adIframe = slideshare_object.topRightAd;
          var src = adSource + encodeURIComponent(";refreshcount=" + refreshCounter);

          var newAdIframe = adIframe.clone(true);
          adIframe.replaceWith(newAdIframe);
          newAdIframe.attr('src', src);

          slideshare_object.topRightAd = newAdIframe;
        }
      };
    })());

    var adLoadInterval = window.setInterval((function () {
      var transcriptAdTop, adiframe, jqWindow, viewPortHeight;
      adiframe = $(".transcriptAd iframe");
      if (!adiframe.length) {
        return function () {
          // Must return a function, else causes Invalid Argument error in IE8/9
          window.clearInterval(adLoadInterval);
        };
      }
      jqWindow = $(window);
      viewPortHeight = jqWindow.height();
      transcriptAdTop = $(".footer-leaderboard-ad").offset().top;
      var loadBelowTranscriptAd = function () {
        slideshare_object.loadDelayedLIAd(adiframe, $(".transcriptAd a.j-cta_remove_ad_fancy"));
      };
      var delayedAdLoad = function () {
        if (jqWindow.scrollTop() + viewPortHeight >= transcriptAdTop) {
          loadBelowTranscriptAd();
          window.clearInterval(adLoadInterval);
        }
      };
      return delayedAdLoad;
    })(), 1000);

    slideshare_object.action_from_email_check();
  });

  // On clicking one of the transcript items, the click should be tracked,
  // the slide should switch, the appropriate transcript items should be
  // shown/hidden, and the page should scroll to the top.
  $('.j-slide_link').click(function (e) {
    e.preventDefault();

    if (!slideshare_object.bambooleaf_transcript_clicks) {
      slideshare_object.bambooleaf_transcript_clicks = 0;
    }
    slideshare_object.bambooleaf_transcript_clicks++;
    var slide = $(this).data('slide');

    $.slideshareEventManager && $.slideshareEventManager.trackRawEvent(
      'bambooleaf_transcript_click',
      slideshare_object.jsplayer.id + '-' + slide,
      slideshare_object.bambooleaf_transcript_clicks + '',
      false
    );

    window.player.goToSlide({ index: slide });
    window.scrollTo(0, 0);
  });

  var update_bambooleaf_properties = function (opts) {
    var startSlide = window.player.config.start_slide;
    if (!slideshare_object.$j_transcript) {
      slideshare_object.$j_transcript = $('.j-transcript');
    }
    if (!slideshare_object.$j_title_breadcrumb) {
      slideshare_object.$j_title_breadcrumb = $('.j-title-breadcrumb');
    }
    if (!slideshare_object.$j_parent_title) {
      slideshare_object.$j_parent_title = $('.j-parent-title');
    }
    // Update Transcript Link Visibility
    if (opts.index === 1) {
      slideshare_object.$j_transcript.show();
    } else if (!opts.isHash) {
      slideshare_object.$j_transcript.hide();
    }
    if (opts.index === startSlide) {
      slideshare_object.$j_title_breadcrumb.show();
      slideshare_object.$j_parent_title.removeClass('low-key-link');
    } else if (startSlide > 1) {
      slideshare_object.$j_title_breadcrumb.hide();
      slideshare_object.$j_parent_title.addClass('low-key-link');
    }
    // Update Window URL
    window.history.replaceState({}, "", opts.newURL);
  };

  // Bind slidechanged to the updates required to SV by bambooleaf
  if (typeof window.player !== 'undefined') {
    $(window.player).bind('slidechanged', function (e) {
      if (this.config.bambooleaf_enabled) {
        update_bambooleaf_properties({
          index: e.ssData.index,
          isHash: this.config.bambooleaf_hash,
          newURL: this.config.rel_slide_urls[e.ssData.index - 1],
        });
      }
    });
  }


  slideshare_object.timer.end = (new Date()).getTime();
  if (slideshare_object.dev && window.console) {
    console.log("ready:",
      slideshare_object.timer.ready - slideshare_object.timer.start,
      "total:", slideshare_object.timer.end - slideshare_object.timer.start);
  }
});
